/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_ContextInputs */

const en_gc_story_context = /** @type {(inputs: Gc_Story_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Think of it as another place to explore a workbook, rather than a promise that every Excel feature will behave identically. It is useful to try a household budget, a class gradebook or a sales summary and see how the workflow feels. This independent site brings together the official browser build, practical tutorials and direct release links. The software comes from ArtCraft; the guidance and website are maintained separately.`)
};

const zh_gc_story_context = /** @type {(inputs: Gc_Story_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以把它看作探索工作簿的另一种选择，而非所有 Excel 功能都完全一致的承诺。用家庭预算、班级成绩册或销售汇总试一试，就能判断工作流程是否适合你。这个独立网站汇集官方浏览器版本、实用教程和直接下载链接。软件由 ArtCraft 开发，本站内容与指南独立维护。`)
};

/**
* | output |
* | --- |
* | "Think of it as another place to explore a workbook, rather than a promise that every Excel feature will behave identically. It is useful to try a household b..." |
*
* @param {Gc_Story_ContextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_context = /** @type {((inputs?: Gc_Story_ContextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_ContextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_context(inputs)
	return zh_gc_story_context(inputs)
});
export { gc_story_context as "gc.story.context" }